import i18n from '@/i18n'
import { computed } from '@vue/composition-api'
import { Contact } from '@/api/model/contact'

export function useGender() {
    const genderOptions = computed(() => Contact.validGenders
        .map(gender => ({
            label: i18n.t(`gender.${gender}`),
            value: gender,
        })))

    return {
        genderOptions,
    }
}
